<!-- eslint-disable max-len -->
<template>
  <div class="about-project_apt" :class="{ [curTheme]: true }">

    <page-header>
      <h1>О проекте</h1>
    </page-header>

    <page-text>
      <p>IPUniversity &ndash; специализированная цифровая платформа обмена знаниями и управления авторскими правами, работающая на основе технологии распределённого реестра (блокчейн). Проект призван способствовать формированию новых подходов к управлению цифровыми объектами авторского права (ЦОАП), повышению прозрачности, скорости и результативности работы ученых.</p>
      <p>Платформа IPUniversity позволяет оперативно и надежно регистрировать ЦОАП в распределённом реестре и управлять правами на объекты, заключая мгновенные договоры на основе смарт-контрактов.</p>
      <p>Проект рассчитан на вузовское и академическое сообщество: ученых-исследователей, преподавателей. Итогом проекта должно стать появление к концу 2019 года масштабного банка цифровых объектов авторского права и платформы с возможностью фиксации авторских прав, депонирования объектов, системой поиска и обмена объектами между обучающимися, преподавателями и исследователями ведущих университетов страны.</p>
    </page-text>

    <page-footer/>
  </div>
</template>

<script>
import PageHeader from '../PageHeader';
import PageText from '../PageText';
import PageFooter from '../PageFooter';

export default {
  components: { PageHeader, PageText, PageFooter },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/layouts/AboutProject.vue